<ng-container *ngFor="let i of items;let index = index ;trackBy:trackById">
  <div @fadeSlideInOut *ngIf="index === displayedIndex" class="notification_container py-2 px-3 d-flex gap-8 justify-content-between subtitle_1" (click)="goToPage(i)">

    <lf-icon name="Notif" height="{{isMobile ? '20px' : '16px'}}" width="{{isMobile ? '20px' : '16px'}}"></lf-icon>
    <div class="d-flex flex-column flex-md-row gap-8 px-3">
      <p class="text-nowrap">
        {{ ('PROCESSES.NOTIFICATION.' + i['notification'].type.toUpperCase() + '_' + i['notification'].name.toUpperCase() + '.CONTENT') | translate }}
      </p>
      <button role="button" type="button" class="btn btn-link border-0 p-0 m-0">
        {{ ('PROCESSES.NOTIFICATION.' + i['notification'].type.toUpperCase() + '_' + i['notification'].name.toUpperCase() + '.CTA') | translate }}
      </button>
    </div>

    <button role="button" type="button" class="btn border-0 m-0 p-0 h-fit-content" (click)="$event.stopPropagation(); close()">
      <lf-icon name="cross" height="{{isMobile ? '16px' : '10px'}}" width="{{isMobile ? '16px' : '10px'}}"></lf-icon>
    </button>

  </div>
</ng-container>

